import React from "react";
import { cn } from "../../../lib/utils";
import { Input } from "../../ui/input";

/**
 * Specify field shown under a selected Other choice.
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} [props.value]
 * @param {function(string): void} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.readOnly]
 * @returns {JSX.Element}
 */
export default function OtherSpecifyField({ id, value = "", onChange, error, readOnly }) {
  return (
    <div className="pl-7 pt-1">
      <Input
        id={id}
        value={value}
        placeholder="Please specify"
        maxLength={500}
        disabled={readOnly}
        aria-invalid={Boolean(error)}
        onChange={(e) => onChange(e.target.value)}
        className={cn(error ? "border-error" : undefined)}
      />
      {error ? (
        <p className="mt-1 text-sm text-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
